module.exports = __webpack_public_path__ + "static/img/img-9.c394eb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-9.png
// module id = fUJh
// module chunks = 1